import React, { Component } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "../tooltip/Tooltip";
import infoIcon from "../../../assets/img/infoIcon.png";
import "./InfoTooltip.css";
class InfoTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderTooltipTitle = () => {
    return (
      <>
        <div className="d-flex flex-row">
          {this.props.data}
          <br />
        </div>
      </>
    );
  };
  render() {
    return (
      <Tooltip
        open={this.props.open}
        placement="bottom"
        title={this.renderTooltipTitle()}
        id="password-requirements-tooltip"
      >
        <span className={this.props.pageId !== "registration" && "ms-1"}>
          {/* <InfoOutlinedIcon
            style={{
              float: "none",
              cursor: "pointer",
              fontSize: "14px",
              color: this.props.pageId === "Dashboard" ? "#fff" : "#353538",
            }}
          /> */}
          <div
            className={
              this.props.pageId === "Dashboard"
                ? "white-info-icon"
                : "info-icon"
            }
          ></div>
        </span>
      </Tooltip>
    );
  }
}

export default InfoTooltip;
